import type {CustomerProfileOverviewContext} from "~/components/entityProfile/overview/types";
import {ProfileOverviewMetricStrip} from "~/components/entityProfile/overview/profileOverviewMetricStrip";
import {ProfileOverviewRecentActivity} from "~/components/entityProfile/overview/profileOverviewRecentActivity";
import {ProfileOverviewRecentLifecycles} from "~/components/entityProfile/overview/profileOverviewRecentLifecycles";

export function ProfileOverviewTabView({overview}: {overview: CustomerProfileOverviewContext}) {
    return (
        <div className="h-full min-h-0 overflow-y-auto overscroll-contain px-ds-space-200 py-ds-space-150">
            <div className="grid gap-y-ds-space-300">
                <ProfileOverviewMetricStrip
                    title="Lifecycle Summary"
                    metrics={overview.lifecycleSummary}
                />
                <ProfileOverviewMetricStrip title="Event Summary" metrics={overview.eventSummary} />
                <ProfileOverviewRecentLifecycles
                    lifecycles={overview.recentLifecycles}
                    onViewAll={overview.onViewAllLifecycles}
                />
                <ProfileOverviewRecentActivity
                    activity={overview.activity}
                    onSeeAll={overview.onViewAllActivity}
                />
            </div>
        </div>
    );
}
